export const mainContainerStyle = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  padding: '0 0',
  width: '100%',
  'box-shadow': 'none',
}
